import ApiError403Handler from './ApiError403Handler'
import { ApiErrorTransformer } from './ApiErrorTransformer'

const STATUS_CODE = 422

class ApiError422Handler {
  handleError (error) {
    if (error.response.status === STATUS_CODE) {
      const apiErrorTransformer = new ApiErrorTransformer()

      console.log(error.response);


      return apiErrorTransformer.transformErrorToString(error.response)
    }

    return ApiError403Handler.handleError(error)
  }
}

export default new ApiError422Handler()
